import { AbstractModel } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { Driver } from './driver';

@inheritSerialization(AbstractModel)
export class JourneyInterestedDriver extends AbstractModel {
  @autoserializeAs(Driver)
  driver: Driver;

  @autoserialize
  journeyId: number;

  @autoserialize
  vehicleId: number;

  @autoserialize
  active: boolean;
}
